import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { promise } from 'protractor';
import { nkServices } from '../servicios/app.nkservicios.services';
import { ToastNotificationService } from '../servicios/toast-notification.service';
import { AppUtilService } from '../servicios/app.util.service';
import { AtributosService } from '../servicios/atributos.service';
import { HashKeyServices } from '../servicios/app.hashkey.services';
import { environment } from 'src/environments/environment';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_usaAlbersHigh from '@amcharts/amcharts4-geodata/usaAlbersHigh';
import ak2023Low from '@amcharts/amcharts4-geodata/region/usa/congressional2022/akLow';
import { FormmMsgComponent } from '../modal/formm-msg/formm-msg.component';
import { MatDialog } from '@angular/material/dialog';
import { parseInt } from 'lodash';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  mapChart: any;
  exp_us: any = '0';
  h2: any = '0';
  selectedStateCode = 'US-TN';
  mapa_usa = true;
  lec_usa = true;
  tar_usa = true;
  mapa_usa_div;
  tituloapp:any;
  company:any;
  masa:any ='';
  masa_multi: any = {};
  map_d_8:any =false;
  map_d_5:any =false;
  map_d_3:any =false;
  map_d_2:any =false;
  map_d_1:any =true;
  cabeza:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  ojo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  boca:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  brazo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  pie:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  nombre:any;
  estado_us:any;
  estado_us_rev:any;
  estado_us_img:any;
  arry:any = [];
  arry_1:any = [];
  arry_2:any = [];
  test:any;
  test_final:any;
  text:any;
  text_cat:any;
  text_v:any;
  text_f:any;
  text_f_2:any;
  text_t:any;
  con:any = false;
  b_sig:any = false;
  b_rp:any = true;
  cont:any = 0;
  cont_test:any = 0;
  cont_test_ev:any = 0;
  cont_test_err:any = 0;
  test_f:any = false;
  test_n:any = [];
  arry_control:any = [];
  arry_control_pares:any = [];
  param:any;
  param_2:any;
  param_3:any = true;
  id_leccion:any;
  id_leccion_tarea:any;
  img_level_1 = ''
  constructor(
              private toast:ToastNotificationService,
              private dialog: MatDialog,
              private servicio:nkServices,
              private util:AppUtilService,
              private atrb:AtributosService,
              private hashkey:HashKeyServices,
              private notifi:ToastNotificationService,
              ){}

 async ngOnInit(){
    this.nombre  = !localStorage.getItem('nombre') ? '': this.hashkey.decrypt(localStorage.getItem('nombre'));
    let val_objeto = await this.hashkey.decrypt(localStorage.getItem('vtr')).split(',');
    this.cabeza = environment.path_storage+val_objeto[0];
    this.ojo = environment.path_storage+val_objeto[1];
    this.boca = environment.path_storage+val_objeto[2];
    this.brazo = environment.path_storage+val_objeto[3];
    this.pie = environment.path_storage+val_objeto[4];
  }
 async ngOnChanges(changes: SimpleChanges){
    const change = JSON.parse(JSON.stringify(changes.ids)) 
    change.currentValue.forEach(data => {
      document.getElementById('MA').style.fill ="#518a38"; 
    });
    let val_objeto = await this.hashkey.decrypt(localStorage.getItem('vtr')).split(',');
    this.cabeza = environment.path_storage+val_objeto[0];
    this.ojo = environment.path_storage+val_objeto[1];
    this.boca = environment.path_storage+val_objeto[2];
    this.brazo = environment.path_storage+val_objeto[3];
    this.pie = environment.path_storage+val_objeto[4];
  } 
    ngAfterViewInit() {
      this.renderStateMap(false);
  //   this.renderDistrictMap(false);
  }
  mouseEnter(id){
    document.getElementById(id).style['stroke-width']= "1.970631";
    document.getElementById(id).style['fill']= "#D0E6FB";
  }
  mouseLeave(id){
    document.getElementById(id).style['stroke-width']= "0.970631";  
    document.getElementById(id).style['fill']= "#3c71d4";
  }

  async stateDrillDown(value) {
    try {
      await this.util.abrirSpinner();
      await this.servicio.consultar_sesionhttp(null).toPromise();
      this.estado_us_rev = value.toUpperCase();
      this.selectedStateCode=value;
    this.masa_multi = [];
    let estado = false;
    let id;
    let xvalor = {
      cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
      cod_app: await this.atrb.COD_APP.cod_app,
      param: 1,
      api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
    };
    const response = await this.servicio.ApiResthttp(xvalor).toPromise();
    for (const i in response) {
      if (response[i].val_def.toUpperCase() === value.toUpperCase() && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          this.estado_us_img = response[i].cod_img;
          estado = true;
          this.estado_us = response[i].val_cat;
          id = response[i].id_relacion_definicion_app.toString();
      }
    }
    if (!estado) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.estado_sin_parametros);
      return;
    }
    this.arry = [];
    console.log(value);
    if (value.toUpperCase() !== await this.atrb.USA_NOM.us_ak.toUpperCase() &&
        value.toUpperCase() !== await this.atrb.USA_NOM.us_hi.toUpperCase() &&
        value.toUpperCase() !== await this.atrb.USA_NOM.us_mi.toUpperCase() && 
        value.toUpperCase() !== await this.atrb.USA_NOM.us_va.toUpperCase() && 
        value.toUpperCase() !== await this.atrb.USA_NOM.us_wv.toUpperCase() && 
        value.toUpperCase() !== await this.atrb.USA_NOM.us_ny.toUpperCase() && 
        value.toUpperCase() !== await this.atrb.USA_NOM.us_ri.toUpperCase() && 
        value.toUpperCase() !== await this.atrb.USA_NOM.us_fl.toUpperCase()) {
          let xvalor = {
            cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
            cod_app: await this.atrb.COD_APP.cod_app,
            param: 2,
            api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
          };
          const response = await this.servicio.ApiResthttp(xvalor).toPromise();
          let val_cat;
          for (const i in response) {
            val_cat = response[i].val_cat.split(',');
            if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
              response[i].cod_img = environment.path_storage+response[i].cod_img;
              response[i].id_padre = val_cat[0];
              response[i].des_param = val_cat[1];
              this.arry.push(response[i]);
            }
          }
          console.log(this.arry);
      let xobjeto = await this.atrb.USA_NOM;
      let mapa = await this.atrb.USA_MAP;
      let nom_map = Object.keys(xobjeto).filter(i => xobjeto[i].toUpperCase() === value.toUpperCase());
      let indice_map = mapa[nom_map[0]];
      if (indice_map) {
        this.masa = indice_map;
        this.mapa_usa_div = document.getElementById('usa_map');
        this.mapa_usa_div.style.display = 'none';
        this.map_d_1 = true;
        this.map_d_8 = false;
        this.map_d_3 = false;
        this.map_d_2 = false;
        this.mapa_usa = false;
      }
      
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_ak.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = true;
      this.map_d_2 = false;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_ak.d1,
        d2: await this.atrb.USA_MAP.us_ak.d2,
        d3: await this.atrb.USA_MAP.us_ak.d3,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_mi.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = true;
      this.map_d_2 = false;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_mi.d1,
        d2: await this.atrb.USA_MAP.us_mi.d2,
        d3: await this.atrb.USA_MAP.us_mi.d3,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_fl.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = false;
      this.map_d_2 = true;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_fl.d1,
        d2: await this.atrb.USA_MAP.us_fl.d2,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_va.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = false;
      this.map_d_2 = true;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_va.d1,
        d2: await this.atrb.USA_MAP.us_va.d2,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_wv.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = false;
      this.map_d_2 = true;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_wv.d1,
        d2: await this.atrb.USA_MAP.us_wv.d2,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_ny.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_3 = false;
      this.map_d_2 = true;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_ny.d1,
        d2: await this.atrb.USA_MAP.us_ny.d2,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_ri.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = false;
      this.map_d_5 = true;
      this.map_d_3 = false;
      this.map_d_2 = false;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_ri.d1,
        d2: await this.atrb.USA_MAP.us_ri.d2,
        d3: await this.atrb.USA_MAP.us_ri.d3,
        d4: await this.atrb.USA_MAP.us_ri.d4,
        d5: await this.atrb.USA_MAP.us_ri.d5,
      };
    }
    if (value.toUpperCase() === await this.atrb.USA_NOM.us_hi.toUpperCase()) {
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        param: 2,
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      let val_cat;
      for (const i in response) {
        val_cat = response[i].val_cat.split(',');
        if (parseInt(val_cat[0]) === parseInt(id) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          response[i].id_padre = val_cat[0];
          response[i].des_param = val_cat[1];
          this.arry.push(response[i]);
        }
      }
      console.log(this.arry);
      this.mapa_usa_div = document.getElementById('usa_map');
      this.mapa_usa_div.style.display = 'none';
      this.map_d_8 = true;
      this.map_d_3 = false;
      this.map_d_2 = false;
      this.map_d_1 = false;
      this.mapa_usa = false;
      this.masa_multi = {
        d1: await this.atrb.USA_MAP.us_hi.d1,
        d2: await this.atrb.USA_MAP.us_hi.d2,
        d3: await this.atrb.USA_MAP.us_hi.d3,
        d4: await this.atrb.USA_MAP.us_hi.d4,
        d5: await this.atrb.USA_MAP.us_hi.d5,
        d6: await this.atrb.USA_MAP.us_hi.d6,
        d7: await this.atrb.USA_MAP.us_hi.d7,
        d8: await this.atrb.USA_MAP.us_hi.d8,
      };
    }
    await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    } 
  }
  async cargarclase(value) {
    try {
      await this.util.abrirSpinner();
      await this.servicio.consultar_sesionhttp(null).toPromise();
    let estado = false;
    let id;
    let arry = [];
    let xval;
    let xvalor = {
      cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
      cod_app: await this.atrb.COD_APP.cod_app,
      param: 3,
      api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
    };
    console.log(value);
    const response = await this.servicio.ApiResthttp(xvalor).toPromise();
    for (const i in response) {
      id = response[i].val_cat.split(',');
      if (parseInt(id[0]) === parseInt(value.id_relacion_definicion_app) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
        xval = {
          cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
          cod_app: await this.atrb.COD_APP.cod_app,
          cod_usuario: await this.atrb.COD_USUARIO.cod_usuario,
          val_cat: response[i].id_relacion_definicion_app,
          api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarRelacionUsuarioApp),
        };
        const response_ = await this.servicio.ApiResthttp(xval).toPromise();
        console.log(response_.length);
          if (response_.length <= 0) {
            response[i].cod_img = environment.path_storage+response[i].cod_img;
          }
          if (response_.length === 1) {
            response[i].cod_img = await this.atrb.IMAGENES_FIJAS.img_level_1;
          }
          if (response_.length === 2) {
            response[i].cod_img = await this.atrb.IMAGENES_FIJAS.img_level_2;
          }
          if (response_.length === 3) {
            response[i].cod_img = await this.atrb.IMAGENES_FIJAS.img_level_3;
          }
          if (response_.length === 4) {
            response[i].cod_img = await this.atrb.IMAGENES_FIJAS.img_level_4;
          }
          estado = true;
          this.estado_us = response[i].val_cat;
          id = response[i].id_relacion_definicion_app.toString();
          arry.push(response[i]);
      }
    }
    if (!estado) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.estado_sin_parametros);
      return;
    }
    this.arry_1 = [];
    this.arry_1 = [...arry];
    this.mapa_usa = true;
    this.lec_usa = false;
    await this.util.cerrarSpinner();
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    } 
  }
  async cargarLeccion(value) {
    try {
      await this.util.abrirSpinner();
      await this.servicio.consultar_sesionhttp(null).toPromise();
      this.id_leccion = value;
    let estado = false;
    let id;
    let arry = [];
    let xvalor = {
      cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
      cod_app: await this.atrb.COD_APP.cod_app,
      param: 4,
      api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
    };
    const response = await this.servicio.ApiResthttp(xvalor).toPromise();
    for (const i in response) {
      id = response[i].val_cat.split(',');
      if (parseInt(id[0]) === parseInt(value.id_relacion_definicion_app) && response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase()) {
          response[i].cod_img = environment.path_storage+response[i].cod_img;
          estado = true;
          this.estado_us = response[i].val_cat;
          id = response[i].id_relacion_definicion_app.toString();
          arry.push(response[i]);
      }
    }
    if (!estado) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.estado_sin_parametros);
      return;
    }
    let xval = {
      cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
      cod_app: await this.atrb.COD_APP.cod_app,
      cod_usuario: await this.atrb.COD_USUARIO.cod_usuario,
      api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarRelacionUsuarioApp),
    };
    const response_ = await this.servicio.ApiResthttp(xval).toPromise();
    if (response_.length <= 0) {
      console.log(arry);
      this.id_leccion_tarea = arry[0];
      await this.util.cerrarSpinner();
      await this.cargarDinamicas(arry[0]);
    }else{
      console.log(response_);
      console.log(arry);
      let xobjeto = [...arry];
      let arry_lec;
      let arry_loop;
      let arry_loop_;
      for (const i in response_) {
        arry_loop = response_[i].val_cat;
        for (const k in arry) {
          arry_loop_ = arry[k].val_cat.split(',');
          if (parseInt(arry_loop) === parseInt(arry_loop_[0])) {
            console.log(response_[i].val_def);
            xobjeto = xobjeto.filter(valor => valor.val_def.toUpperCase() !== response_[i].val_def.toUpperCase());
          }
        }
      }
      console.log(xobjeto);
      await this.util.cerrarSpinner();
      this.id_leccion_tarea = xobjeto[0];
      if (xobjeto.length <= 0) {
        await this.notifi.success(await this.atrb.MENSAJES_FIJOS.final_clase);
      }else{
        await this.cargarDinamicas(xobjeto[0]);
      }
    }
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    } 
  }
  async cargarDinamicas(value) {
    try {
      await this.util.abrirSpinner();
      await this.servicio.consultar_sesionhttp(null).toPromise();
      await this.util.cerrarSpinner();
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:''},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
         await this.util.cerrarSpinner();
         await this.listarDinamicas(value);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    } 
  }
  async listarDinamicas(value:any){
    try {
      console.log(value);
        await this.util.abrirSpinner();
        let estado = false;
        let id;
        let arry = [];
        let xvalor = {
          cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
          cod_app: await this.atrb.COD_APP.cod_app,
          id_relacion_definicion_app:value.id_relacion_definicion_app.toString(),
          param: 5,
          api:  await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAppInicio),
        };
        const response = await this.servicio.ApiResthttp(xvalor).toPromise();
        for (const i in response) {
          id = response[i].val_cat.split(',');
          if (parseInt(id[0]) === parseInt(value.id_relacion_definicion_app) && 
              response[i].estatus.toUpperCase() === await this.atrb.ACTIVO.toUpperCase() &&
              id.length > 2 
              ) {
              response[i].cod_img = environment.path_storage+response[i].cod_img;
              estado = true;
              arry.push(response[i]);
          }
        }
        if (!estado) {
          await this.util.cerrarSpinner();
          await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.estado_sin_parametros);
          return;
        }
        this.cont_test++;
          let op_ram = [];
          let random = Math.floor((Math.random() * arry.length));
          this.test = arry[random].val_def;
          this.text_cat = arry[random].val_cat.split(',');
          this.text_t = this.text_cat[3];
          this.test_n = [...arry];
          console.log(this.test_n);
          this.text = this.text_cat[5].split(' ');
          /* this.text_v = this.test.split(' '); */
          this.text_v = this.text;
          /* this.text_f = await this.util.arrayRamdom(this.text); */
          op_ram = parseInt(this.text_cat[2]) === 0 ? 
                      [
                        [
                          this.text_cat[4]+'_'+1+'_'+1,
                          this.text_cat[6]+'_'+2+'_'+1,
                          this.text_cat[8]+'_'+3+'_'+1,
                          this.text_cat[10]+'_'+4+'_'+1,
                          this.text_cat[12]+'_'+5+'_'+1,
                        ]
                          ,
                        [
                          this.text_cat[5]+'_'+1+'_'+2,
                          this.text_cat[7]+'_'+2+'_'+2,
                          this.text_cat[9]+'_'+3+'_'+2,
                          this.text_cat[11]+'_'+4+'_'+2,
                          this.text_cat[13]+'_'+5+'_'+2,
                        ]
                      ] : 
                   parseInt(this.text_cat[2]) === 1 ? 
                   [this.text_cat[6], this.text_cat[7], this.text_cat[8], this.text_cat[9],this.text_cat[10],this.text_cat[11]] : [];
          this.text_f = parseInt(this.text_cat[2]) === 0 ? await this.util.arrayRamdom(op_ram[0]) : await this.util.arrayRamdom(op_ram);
          this.text_f_2 = parseInt(this.text_cat[2]) === 0 ? await this.util.arrayRamdom(op_ram[1]) : [];
          console.log(this.text_f);
          console.log(this.text_f_2);
          /* let val = Math.floor((Math.random() * this.text.length) ); */
          let val = this.text_cat[5];
          this.test_n = this.test_n.filter(valor => valor.val_def !== this.test_n[random].val_def);
          this.param_2 = this.text_cat[2].toUpperCase();
          this.param_3 = this.text_cat[4].length > 10 ? false : true;
          for (const i in this.text_v) {
            if (this.text_v[i].toUpperCase() === val.toUpperCase() && this.text_cat[1].toUpperCase() === await this.atrb.COMPLETACION.toUpperCase()) {
              this.text_v[i] = '_ _';
            }
          }
          this.test_final = await this.util.remplazo_coma_espacio(this.text_v.toString());
        this.lec_usa = true;
        this.tar_usa = false;
        await this.util.cerrarSpinner();
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      if (parseInt(error.error.param) === 5) {
        await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.sin_dinamicas);
      }else{
        await this.notifi.customToastNotification(error.error.message);
      }
    }
  }
  async cambiarTest(){
    try {
      await this.util.abrirSpinner();
      console.log(this.test_n);
      if (this.test_n.length <= 0) {
        this.test_f = true;
        await this.util.cerrarSpinner();
        return;
      }
      this.con = false;
      this.b_sig = false;
      this.b_rp = true;
        this.cont_test++;
        let op_ram = [];
        let random = Math.floor((Math.random() * this.test_n.length) );

        this.test = this.test_n[random].val_def;
        this.text_cat = this.test_n[random].val_cat.split(',');
        this.text_t = this.text_cat[3];
        this.text = this.text_cat[5].split(' ');;
        this.text_v = this.text;
        /* op_ram = [this.text_cat[6], this.text_cat[7], this.text_cat[8], this.text_cat[9],this.text_cat[10],this.text_cat[11]]; */
        op_ram = parseInt(this.text_cat[2]) === 0 ? 
                    [
                      [
                        this.text_cat[4]+'_'+1+'_'+1,
                        this.text_cat[6]+'_'+2+'_'+1,
                        this.text_cat[8]+'_'+3+'_'+1,
                        this.text_cat[10]+'_'+4+'_'+1,
                        this.text_cat[12]+'_'+5+'_'+1,
                      ]
                        ,
                      [
                        this.text_cat[5]+'_'+1+'_'+2,
                        this.text_cat[7]+'_'+2+'_'+2,
                        this.text_cat[9]+'_'+3+'_'+2,
                        this.text_cat[11]+'_'+4+'_'+2,
                        this.text_cat[13]+'_'+5+'_'+2,
                      ]
                    ] :  
                   parseInt(this.text_cat[2]) === 1 ? 
                   [this.text_cat[6], this.text_cat[7], this.text_cat[8], this.text_cat[9],this.text_cat[10],this.text_cat[11]] : [];
          this.text_f = parseInt(this.text_cat[2]) === 0 ? await this.util.arrayRamdom(op_ram[0]) : await this.util.arrayRamdom(op_ram);
          this.text_f_2 = parseInt(this.text_cat[2]) === 0 ? await this.util.arrayRamdom(op_ram[1]) : [];
          console.log(this.text_f);
          console.log(this.text_f_2);
        let val = this.text_cat[5];
        this.test_n = this.test_n.filter(valor => valor.val_def !== this.test_n[random].val_def);
        this.param_2 = this.text_cat[2].toUpperCase();
        this.param_3 = this.text_cat[4].length > 10 ? false : true;
        for (const i in this.text_v) {
          if (this.text_v[i].toUpperCase() === val.toUpperCase() && this.text_cat[1].toUpperCase() === await this.atrb.COMPLETACION.toUpperCase()) {
            this.text_v[i] = '_ _';
          }
        }
        this.test_final = await this.util.remplazo_coma_espacio(this.text_v.toString());
        if (this.test_n.length <= 0) {
          this.test_f = true;
          /* this.con = true; */
        }
      await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log();
    }
  }
  async rpctPares(xvalor:any){
    try {
      await this.util.abrirSpinner();
      /* this.b_rp = false;
      this.b_sig = true;
      this.con = true;
      this.cont = 0; */
      if (this.arry_control_pares.length < 5) {
        this.b_sig = false;
      }
      let val = false;
      let xid = document.querySelector(`#${xvalor}`) as HTMLInputElement;
      for (const i in this.arry_control_pares) {
          for (const k in this.arry_control_pares[i]) {
            if (this.arry_control_pares[i][k].toUpperCase() === xvalor.toUpperCase()) {
              val = true;
              break;
            }
        }
       }
       console.log(this.arry_control_pares);
      if (val) {
        let arry_par_copia = [...this.arry_control_pares];
          this.arry_control_pares = arry_par_copia.map(i => i.filter(elem => elem.toUpperCase() !== xvalor.toUpperCase()) );
          arry_par_copia = [...this.arry_control_pares];
          this.arry_control_pares = arry_par_copia.filter(elem => elem.length > 0);
          console.log(this.arry_control_pares);
          xid.style.backgroundColor = 'rgb(255, 255, 255)';
          xid.style.color = 'rgb(0, 0, 0)';
        await this.util.cerrarSpinner();
        /* await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.opcion_selec); */
        return;
      }else{
        let val_ = false;
        for (const i in this.arry_control) {
          if (this.arry_control[i].toUpperCase() === xvalor.toUpperCase()) {
            val_ = true;
            break;
          }
        }
        if (val_) {
          await this.util.cerrarSpinner();
          /* xid.style.backgroundColor = 'rgb(255, 255, 255)';
          xid.style.color = 'rgb(0, 0, 0)'; */
        await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.opcion_selec);
        return;
        }else{
          this.arry_control.push(xvalor);
        }
      }
      
      if (this.arry_control.length > 0) {
        this.cont_test_ev++;
        if (xid.style.backgroundColor === 'rgb(255, 255, 255)') {
          xid.style.backgroundColor = 'rgb(17, 110, 238)';
          xid.style.color = 'rgb(255, 255, 255)';
          if (this.arry_control.length === 2) {
              let col_1;
              let col_2;
              col_1 = this.arry_control[0].split('_');
              col_2 = this.arry_control[1].split('_');
              //validacion que no sea dela misma columna
              if (parseInt(col_1[2]) === parseInt(col_2[2])) {
                await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.col_no_par);
                xid.style.backgroundColor = 'rgb(255, 255, 255)';
                xid.style.color = 'rgb(0, 0, 0)';
                this.arry_control = this.arry_control.filter(i => i.toUpperCase() !== xvalor.toUpperCase());
                await this.util.cerrarSpinner();
                return;
              }else{
                this.arry_control_pares.push(this.arry_control);
                this.arry_control = [];
                console.log(this.arry_control_pares.length);
                if (this.arry_control_pares.length === 5) {
                  this.b_sig = true;
                }
                await this.util.cerrarSpinner();
                return;
              }
          }
          await this.util.cerrarSpinner();
                return;
        }
        if (xid.style.backgroundColor === 'rgb(255, 255, 255)') {
          xid.style.backgroundColor = 'rgb(17, 110, 238)';
          xid.style.color = 'rgb(255, 255, 255)';
          await this.util.cerrarSpinner();
          return;
        }
      }else{
        this.cont_test_err++;
        await this.util.cerrarSpinner();
                return;
        /* console.log(this.cont_test_err,'incorrectas');
        await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.respuesta_incorrecta); */
      }
      await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  async rpctTest(xvalor:any){
    try {
      await this.util.abrirSpinner();
      this.b_rp = false;
      this.b_sig = true;
      this.con = true;
      this.cont = 0;
      console.log(xvalor);
      if (xvalor.toUpperCase() === this.text_cat[4].toUpperCase()) {
        this.cont_test_ev++;
        /* console.log(this.cont_test_ev,'correctas');
        await this.notifi.success(await this.atrb.MENSAJES_FIJOS.respuesta_correcta); */
      }else{
        this.cont_test_err++;
        /* console.log(this.cont_test_err,'incorrectas');
        await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.respuesta_incorrecta); */
      }
      await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log();
    }
  }
  async  modalrespuesta(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
          this.tar_usa = true;
          this.lec_usa = false;
          this.cont_test = 0;
          this.test_f = false;
          this.b_sig = false;
          this.b_rp = true;
          this.arry_control_pares = [];
          this.arry_control = [];
          await this.util.cerrarSpinner();
          console.log(this.id_leccion_tarea);
          await this.getGestionUsuarioApp(this.id_leccion_tarea);
          let id = this.id_leccion.val_cat.split(',');
          let xvalor = {
            id_relacion_definicion_app:id[0]
          }
          await  this.cargarclase(xvalor);
            await this.notifi.success(await this.atrb.MENSAJES_FIJOS.final_tarea);
            await this.util.cerrarSpinner();
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async getGestionUsuarioApp(value:any){
    try {
      let xvalor_ = value.val_cat.split(',');
      let xvalor = {
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        cod_app: await this.atrb.COD_APP.cod_app,
        cod_usuario: await this.atrb.COD_USUARIO.cod_usuario,
        des_usuario: await this.atrb.NOMBRE_USUARIO.nombre,
        val_def: value.val_def,
        val_cat: xvalor_[0].toLowerCase(),
        id_relacion_definicion_app:value.id_relacion_definicion_app.toString(),
        api:  await this.hashkey.encrypt(await this.atrb.API_REST.gestionUsuarioApp),
      };
      const response = await this.servicio.ApiResthttp(xvalor).toPromise();
      console.log(response.message);
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  selectState(statecode:string) {
    this.selectedStateCode=statecode;
    this.renderStateMap(true);
  }

  renderStateMap(stateSelectedFlag: boolean) {
    let componentScope = this;
    /* am4core.useTheme(am4themes_animated); */
    var container = am4core.create('usa_map', am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);
    this.mapChart = container.createChild(am4maps.MapChart);
    this.mapChart.geodata = am4geodata_usaAlbersHigh;
    this.mapChart.projection = new am4maps.projections.Miller();
    var polygonSeries = this.mapChart.series.push(
      new am4maps.MapPolygonSeries()
    );
    polygonSeries.useGeodata = true;
    polygonSeries.mapPolygons.template.fill = am4core.color('#3c71d4');
    var polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}';
    polygonTemplate.fill = am4core.color('#3c71d4');

    var hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#D0E6FB');

    var hsa = polygonTemplate.states.create('click');
    hsa.properties.fill = am4core.color('#D0E6FB');

    var activeState = polygonTemplate.states.create('active');
    activeState.properties.fill = am4core.color('#D0E6FB');
    polygonSeries.mapPolygons.template.events.on('hit', function (ev) {
      polygonSeries.mapPolygons.each(function (polygon) {
        //console.log(polygon.uid);
        polygon.isActive = false;
      });
      ev.target.isActive = true;
      var statecode = ev.target.dataItem.dataContext.id;
      console.log('STATE CODE' + statecode);
      componentScope.stateDrillDown(statecode);

    });

    if (stateSelectedFlag) {
      var selectedStates = [];
      selectedStates.push(componentScope.selectedStateCode);
      console.log('selectedStates::::' + selectedStates);
      var data = [];
      selectedStates.map(function (id) {
        data.push({
          id: id,
          color: '#D0E6FB',
        });
      });
      polygonTemplate.propertyFields.fill = 'color';
      polygonSeries.data = data;
    }
  }

  renderDistrictMap(stateSelectedFlag: any) {
    let componentScope = this;
    //am4core.useTheme(am4themes_animated);
    var container = am4core.create('usa_map', am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);
    this.mapChart = container.createChild(am4maps.MapChart);
    this.mapChart.geodata = ak2023Low;
    this.mapChart.projection = new am4maps.projections.Miller();
    var polygonSeries = this.mapChart.series.push(
      new am4maps.MapPolygonSeries()
    );
    polygonSeries.useGeodata = true;
    polygonSeries.mapPolygons.template.fill = am4core.color('#3c71d4');
    var polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}';
    polygonTemplate.fill = am4core.color('#3c71d4');

    var hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#D0E6FB');

    var hsa = polygonTemplate.states.create('click');
    hsa.properties.fill = am4core.color('#FF0000');

    var activeState = polygonTemplate.states.create('active');
    activeState.properties.fill = am4core.color('#800080');
    polygonSeries.mapPolygons.template.events.on('hit', function (ev) {
      polygonSeries.mapPolygons.each(function (polygon) {
        //console.log(polygon.uid);
        polygon.isActive = false;
      });
      ev.target.isActive = true;
      var statecode = ev.target.dataItem.dataContext.id;
      console.log('STATE CODE' + statecode);
      componentScope.stateDrillDown(statecode);

    });

    if (stateSelectedFlag) {
      var selectedStates = [];
      selectedStates.push(componentScope.selectedStateCode);
      console.log('selectedStates::::' + selectedStates);
      var data = [];
      selectedStates.map(function (id) {
        data.push({
          id: id,
          color: '#800080',
        });
      });
      polygonTemplate.propertyFields.fill = 'color';
      polygonSeries.data = data;
    }
  }
  async cerrarContent(){
    try {
      let accion = '';
      let dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:accion},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if (result !== await this.atrb.CERRAR){
          if (!this.tar_usa) {
            this.tar_usa = true;
            this.lec_usa = false;
            this.cont_test = 0;
            this.test_f = false;
            this.b_rp = true;
            this.b_sig = false;
            this.arry_control = [];
            this.arry_control_pares = [];
            await this.util.cerrarSpinner();
            console.log(this.id_leccion);
            let id = this.id_leccion.val_cat.split(',');
            let xvalor = {
              id_relacion_definicion_app:id[0]
            }
            await  this.cargarclase(xvalor);
          }else{
            if (!this.lec_usa) {
              this.lec_usa = true;
            await this.util.cerrarSpinner();
            await  this.stateDrillDown(this.estado_us_rev);
            }else{
              await this.util.cerrarSpinner();
              this.mapa_usa = true;
              this.mapa_usa_div.style.display = 'block';
            }
          }
        }else{
          await this.util.cerrarSpinner();
       }
      });
    } catch (error) {
      console.log(error);
   }
  }
}
